(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvSearchBox', drvSearchBox);

    drvSearchBox.$inject = [];

    /**
     * Search box used throughout ChilliDocs
     *
     * # Scope Properties
     * {string} title - Title of the search box
     * {string} placeholder - Placeholder for the search box input
     * {number} searchDelay - Delay before the searchText is updated after user input has finished
     * {string} searchText - Search text which has been entered into the search box
     */
    function drvSearchBox() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: function () {},
            controllerAs: 'drvCtrl',
            bindToController: {
                title: '<',
                placeholder: '<',
                searchDelay: '<?',
                searchText: '='
            },
            template:
                '<span layout="row" layout-align="start center" style="position: relative;">' +
                '<input type="text" placeholder="{{drvCtrl.placeholder}}"' +
                '                   title="{{drvCtrl.title}}"' +
                '                   ng-model-options="{ debounce: drvCtrl.searchDelay ? drvCtrl.searchDelay : 0 }"' +
                '                   ng-model="drvCtrl.searchText"' +
                '                   flex="grow"' +
                '                   layout-align="start center">' +
                '<drv-icon usage="\'search\'" style="position: absolute; right: 0px;"></drv-icon>' +
                '</span>'
        };
        return directive;
    }
})();